"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ToolbarButton = _interopRequireDefault(require("../ToolbarButton"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ButtonContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "ButtonTabGroup__ButtonContainer",
  componentId: "sc-1bjda0c-0"
})(["display:flex;flex-wrap:nowrap;position:relative;button{margin:0.25rem 0.5rem;}"]);

var Underline = _styledComponents["default"].span.withConfig({
  displayName: "ButtonTabGroup__Underline",
  componentId: "sc-1bjda0c-1"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;height:0.25rem;top:4.5rem;background-color:", ";transition:left 150ms ease,width 150ms ease;border-radius:0.25rem;"], props.theme.color.action);
});
/**
 *
 * ### Button Group component for tab like functionality.

  To be used with a number of child `ToolbarButton` components which normally will be displayed in a `Toolbar`. The callback event `onChange` will return the details of the currently selected button.

  Note: This component will overwrite the necessary child props to allow the tab functionality to be enabled. For example, both the `active` and `toggleable` states cannot be used within this component and the `value` will be used for the tab index.
 */


var ButtonTabGroup = function ButtonTabGroup(_ref) {
  var children = _ref.children,
      _ref$selectedIndex = _ref.selectedIndex,
      selectedIndex = _ref$selectedIndex === void 0 ? 0 : _ref$selectedIndex,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;

  var containerRef = _react["default"].useRef();

  var _React$useState = _react["default"].useState({
    width: 0,
    left: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      underlineStyle = _React$useState2[0],
      setUnderlineStyle = _React$useState2[1];

  var clampedIndex = Math.min(Math.max(selectedIndex, 0), _react["default"].Children.count(children) - 1);

  function updateUnderLine(activeElement) {
    if (!containerRef.current || !activeElement) return;

    var _containerRef$current = containerRef.current.getBoundingClientRect(),
        containerLeft = _containerRef$current.left;

    var _activeElement$getBou = activeElement.getBoundingClientRect(),
        left = _activeElement$getBou.left,
        width = _activeElement$getBou.width;

    setUnderlineStyle({
      left: left - containerLeft,
      width: width
    });
  }

  function handleButtonChange(event) {
    onChange(event);
  }

  function renderElement(child, index) {
    switch (child.type) {
      case _ToolbarButton["default"]:
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          onClick: handleButtonChange,
          value: index.toString(),
          active: false,
          toggleable: false,
          'aria-selected': index === clampedIndex ? true : false,
          role: 'tab'
        });

      default:
        return child;
    }
  }

  function updateActiveChild() {
    var child = containerRef.current.children[clampedIndex];
    updateUnderLine(child);
  }

  _react["default"].useLayoutEffect(function () {
    updateActiveChild();
    window.addEventListener('load', updateActiveChild);
    return function () {
      window.removeEventListener('load', updateActiveChild);
    };
  }, [selectedIndex]);

  return /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
    role: "tablist",
    ref: containerRef
  }, _react["default"].Children.map(children, renderElement), /*#__PURE__*/_react["default"].createElement(Underline, {
    style: underlineStyle
  }));
};

var _default = ButtonTabGroup;
exports["default"] = _default;